<template>
    <div class="block md:flex lg:w-64 lg:flex-none print:hidden">
        <slot />

        <annotation-base
            :report_user="report_user"
            :scope="scope"
            :sections="sections"
            :section_names="section_names"
            :enabled="state.enableAnnotator"
            :show_author_ids="state.showAuthorIds"
            :self_id="self_id"
            :self="self"
            :show_section_id="show_section_id"
            :for_profile="for_profile"
            :read_only="read_only"
            :enable_private_annotations="enable_private_annotations"
            @fetched="fetchedAnnotations"
        />
    </div>
</template>

<script>
import AnnotationBase from './annotation-base.vue';

export default {
    components: {
        AnnotationBase,
    },

    props: {
        self_id: null,
        show_section_id: null,
        report_user: {},
        scope: { type: String, default: null },
        sections: { type: Object, default: () => { return {} }},
        section_names: { type: Object, default: () => { return {} }},
        for_profile: {},
        read_only: { type: Boolean, default: false },
        self: '',
        enable_private_annotations: { type: Boolean, default: false },
    },

    data() {
        return {
            state: {
                enableAnnotator: true,
                showAuthorIds: [],
            },
            authors: [],
        }
    },

    methods: {
        update(state) {
            this.state = state;
        },
        fetchedAnnotations(annotations) {
            this.authors = _.uniqBy(annotations, 'author_id').map(annotation => {
                return {
                    id: annotation.author_id,
                    name: annotation.author_name,
                };
            });
            this.state.showAuthorIds = this.authors.map(author => author.id),
            this.$root.$emit('fetchedAnnotationAuthors', {
                self_id: this.self_id,
                authors: this.authors,
            });
        },
    },

    created() {
        this.$on('updateAnnotationToggle', this.update);

        //
        // polyfill for IE11, from MDN:
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
        //
        if (! Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
        }

        if (! Element.prototype.closest) {
            Element.prototype.closest = function(s) {
                var el = this;

                do {
                    if (Element.prototype.matches.call(el, s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);

                return null;
            };
        }
    },
}
</script>
